import { render, staticRenderFns } from "./InfoStatistic.vue?vue&type=template&id=266cf7f8&scoped=true"
import script from "./InfoStatistic.vue?vue&type=script&lang=js"
export * from "./InfoStatistic.vue?vue&type=script&lang=js"
import style0 from "./InfoStatistic.vue?vue&type=style&index=0&id=266cf7f8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266cf7f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('266cf7f8')) {
      api.createRecord('266cf7f8', component.options)
    } else {
      api.reload('266cf7f8', component.options)
    }
    module.hot.accept("./InfoStatistic.vue?vue&type=template&id=266cf7f8&scoped=true", function () {
      api.rerender('266cf7f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Before/ProjectInfo/InfoStatistic.vue"
export default component.exports